<div *ngIf="loading" class="loading">
    <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
</div>
<div class="dismissal-tracking-container">
    <div class="dismissal-tracking-container-header" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
        <svg (click)="back()" xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="0 0 6.576 11.257"
            [ngStyle]="{'transform': currLang == 'en' ? 'rotate(0)' : 'rotate(180deg)'}">
            <g id="next_1_" data-name="next (1)" transform="translate(6.022 10.703) rotate(180)">
                <g id="Group_5442" data-name="Group 5442" transform="translate(0 0)">
                    <path id="Path_5603" data-name="Path 5603"
                        d="M107.651,5.354l-4.687,4.687a.391.391,0,0,1-.552-.552l4.411-4.411L102.411.667a.391.391,0,0,1,.552-.552L107.651,4.8A.391.391,0,0,1,107.651,5.354Z"
                        transform="translate(-102.297 0)" fill="#707070" stroke="#707070" stroke-width="1" />
                </g>
            </g>
        </svg>
        <span class="dismissal-tracking-container-header-label">{{'student-dismissal-track.header'| translate}}</span>
        <svg xmlns="http://www.w3.org/2000/svg" style="margin: 0px 20px" width="21.077" height="21.077"
            viewBox="0 0 21.077 21.077" (click)="changeTab()">
            <g id="Component_27_2" data-name="Component 27 – 2" transform="translate(-12)">
                <g id="refresh" transform="translate(12)">
                    <g id="Group_5050" data-name="Group 5050" transform="translate(1.132)">
                        <g id="Group_5049" data-name="Group 5049">
                            <path id="Path_5413" data-name="Path 5413"
                                d="M47.433,2.831a.818.818,0,0,0-.9.726l-.109,1.165a10.557,10.557,0,0,0-18.1.844.791.791,0,0,0,.359,1.079A.836.836,0,0,0,29.8,6.295a8.891,8.891,0,0,1,15.251-.707l-1.176-.816a.84.84,0,0,0-1.15.186.787.787,0,0,0,.192,1.118l3.565,2.475a.829.829,0,0,0,1.3-.58l.4-4.27A.808.808,0,0,0,47.433,2.831Z"
                                transform="translate(-28.237)" fill="#707070" />
                        </g>
                    </g>
                    <g id="Group_5052" data-name="Group 5052" transform="translate(0 12.376)">
                        <g id="Group_5051" data-name="Group 5051">
                            <path id="Path_5414" data-name="Path 5414"
                                d="M19.5,296.97a.836.836,0,0,0-1.109.349,8.891,8.891,0,0,1-15.251.707l1.176.816a.84.84,0,0,0,1.15-.186.787.787,0,0,0-.192-1.118l-3.565-2.475a.829.829,0,0,0-1.3.58l-.4,4.27a.808.808,0,0,0,.746.871.818.818,0,0,0,.9-.726l.109-1.165a10.557,10.557,0,0,0,18.1-.844A.791.791,0,0,0,19.5,296.97Z"
                                transform="translate(-0.001 -294.913)" fill="#707070" />
                        </g>
                    </g>
                </g>
            </g>
        </svg>


    </div>
    <div class="filter-section row">
        <div class="col-6" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
            <span class="title">{{'student-dismissal-track.filter-by'| translate}} :</span>
            <div class="filter-options">
                <div class="item" [class.active]="activeTab == 'students'" (click)="changeTab('students')">
                    {{'student-dismissal-track.students'| translate}}
                </div>
                <div class="item" [class.active]="activeTab == 'staff'" (click)="changeTab('staff')">
                    {{'student-dismissal-track.staff'| translate}}</div>
                <div class="item" [class.active]="activeTab == 'grades'" (click)="changeTab('grades')">
                    {{'student-dismissal-track.grades'| translate}}</div>
            </div>
        </div>
        <ng-container *ngIf="grades.length && activeTab == 'students'">
            <div class="col-3">
                <select class="form-control" [(ngModel)]="selectedGradeindex" (change)="changeTab()">
                    <option [value]="in" *ngFor="let grade of grades, index as in">
                        {{grade.name}}
                    </option>
                </select>
            </div>
            <div class=" col-3">
                <select class="form-control" [(ngModel)]="selectedClassId" (change)="changeTabClass()" [disabled]="noClassFlag">
                    <option [value]="class.id" *ngFor="let class of grades[selectedGradeindex].school_classes">
                        {{class.name}}
                    </option>
                </select>
            </div>
        </ng-container>
    </div>
    <div class="content-container">
        <div class="row" *ngIf="activeTab != 'grades'">
            <div class="col-3 text-center" *ngFor="let element of dataArray">
                <div class="card header">
                    {{element.header}}
                </div>
                <div class="scroll-section">
                    <div class="card" *ngFor="let dataElement of element.dataSet"
                        [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">

                        <div class="row" *ngIf="activeTab == 'students'">
                            <div class="col-3 text-center">
                                <div class="student-img"
                                    [style.backgroundImage]="'url('+ baseuUlr + dataElement.image_path +')'">
                                </div>
                            </div>
                            <div class="col-9">
                                <div>{{dataElement.name}}</div>
                                <div [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                                    <span>{{'student-dismissal-track.grade'| translate}} :</span>
                                    <span
                                        [ngClass]="(currLang =='ar') ? 'float-left':'float-right'">{{dataElement.class?.name}}</span>
                                </div>
                                <div [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                                    <span>{{'student-dismissal-track.class'| translate}} :</span>
                                    <span
                                        [ngClass]="(currLang =='ar') ? 'float-left':'float-right'">{{dataElement.class?.grade.name}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="activeTab == 'staff'" (mouseleave)="extend(dataElement, false)">
                            <div class="col-12">
                                <div>{{dataElement.name}}</div>
                                <div *ngIf="element.header == 'Teachers' ||element.header == 'مدرسين'"
                                    class="multi-line" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                                    <span>{{'student-dismissal-track.class'| translate}}:</span>
                                    <span [ngClass]="(currLang =='ar') ? 'float-left':'float-right'">
                                        <span class="link" (click)="extend(dataElement, true)"
                                            *ngIf="!dataElement.extendFlag && dataElement.classes.length > 1">{{dataElement.classes.length}}
                                            {{'student-dismissal-track.classes'| translate}}</span>
                                        <ng-container *ngIf="dataElement.extendFlag || dataElement.classes.length == 1">
                                            <span *ngFor="let class of dataElement.classes">
                                                {{class.name}} ({{class.grade.name}}) <br>
                                            </span>
                                        </ng-container>
                                    </span>
                                </div>
                                <div *ngIf="element.header == 'Viewers' || element.header == 'المتابعين'"
                                    class="multi-line" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                                    <span>{{'student-dismissal-track.grade'| translate}}:</span>
                                    <span [ngClass]="(currLang =='ar') ? 'float-left':'float-right'">
                                        <span class="link" (click)="extend(dataElement, true)"
                                            *ngIf="!dataElement.extendFlag && dataElement.grades.length > 1">{{dataElement.grades.length}}
                                            {{'student-dismissal-track.grades'| translate}}</span>
                                        <ng-container *ngIf="dataElement.extendFlag || dataElement.grades.length == 1">
                                            <span *ngFor="let grade of dataElement.grades">
                                                {{grade.name}} <br>
                                            </span>
                                        </ng-container>
                                    </span>
                                </div>
                                <div *ngIf="element.header == 'Guards' || element.header == 'حراس'" class="multi-line"
                                    [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                                    <span>{{'student-dismissal-track.gate'| translate}}:</span>
                                    <span [ngClass]="(currLang =='ar') ? 'float-left':'float-right'">
                                        <span class="link" (click)="extend(dataElement, true)"
                                            *ngIf="!dataElement.extendFlag && dataElement.gates.length > 1">{{dataElement.gates.length}}
                                            {{'student-dismissal-track.gates'| translate}}</span>
                                        <ng-container *ngIf="dataElement.extendFlag || dataElement.gates.length == 1">
                                            <span *ngFor="let gate of dataElement.gates">
                                                {{gate.name}} <br>
                                            </span>
                                        </ng-container>
                                    </span>
                                </div>
                                <div *ngIf="element.header == 'Busses' ||element.header == 'الحافلات'"
                                    [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                                    <span>{{'student-dismissal-track.route'| translate}} :</span>
                                    <span [ngClass]="(currLang =='ar') ? 'float-left':'float-right'">
                                        <span>{{dataElement.driver_route?.route_name}}</span>
                                    </span>
                                </div>
                                <div>
                                    <span>{{'student-dismissal-track.delivered-students'| translate}} :</span>
                                    <span
                                        [ngClass]="(currLang =='ar') ? 'float-left':'float-right'">{{dataElement.delivered_students_count
                                        +'/'+ dataElement.total_students_count}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row scroll-section" style="margin-top: 30px;" *ngIf="activeTab == 'grades'">
            <div class="col-3 text-center" *ngFor="let element of dataArray">
                <div class="card">
                    <div class="row">
                        <div class="col-12">
                            <div class="header text-center">{{element.name}}</div>
                            <div *ngFor="let class of element.school_classes"
                                [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
                                <span>{{class.name}}</span>
                                <span
                                    [ngClass]="(currLang =='ar') ? 'float-left':'float-right'">{{class.delivered_students
                                    + '/' + class.total_students }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>